import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CDFlorderType } from '../../../core/store/contract-details/contract-details.interface';
import { OrderDetail, OrderMaterial, OrderPlanning, } from '../../../core/store/edit-florder-detail/florder-detail.interface';
import { FlorderEditDetailComponent } from '../../florder/florder-edit-detail/florder-edit-detail.component';
import { ScrollService } from '../../../core/services/scroll.service';

@Component({
  selector: 'app-ccr-edit-detail',
  templateUrl: './ccr-edit-detail.component.html',
  styleUrls: ['../../florder/florder-edit-detail/florder-edit-detail.component.scss'],
})
export class CCREditDetailComponent extends FlorderEditDetailComponent<OrderMaterial, OrderDetail, OrderPlanning> {
  _orderTypes: CDFlorderType[];

  @Input() orderDetail: OrderDetail;
  @Input() ccrForm: UntypedFormGroup;

  @Input()
  set orderTypes(orderTypes: CDFlorderType[]) {
    this._orderTypes = orderTypes;
  }

  get orderTypes(): CDFlorderType[] {
    return this._orderTypes;
  }

  get florderDetail(): OrderDetail {
    return this.orderDetail;
  }

  constructor(scrollService: ScrollService) {
    super(scrollService);
  }

  isValid(): boolean {
    const valid = this.florderDetail.ccr.ccrLineItems.length > 0;
    return valid;
  }
}
